class CartCheckboxUpsell {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
    this.baseUrl = '/cart';
    this.checkboxUpsellVariantId = this.getUpsellCheckboxVariantId();
    this.isMutating = false;
    this.initEventDelegation();
    document.addEventListener('cartUpdated', this.handleCartUpdate.bind(this));
    this.updateCheckboxState();
  }

  initEventDelegation() {
    document.body.addEventListener('change', (event) => {
      if (event.target.id === 'cart-upsell-checkbox') {
        if (this.isMutating) return;
        const isChecked = event.target.checked;
        this.isMutating = true;
        event.target.disabled = true;
        const mutation = isChecked
          ? this.addUpsellCheckboxToCart()
          : this.removeUpsellCheckboxFromCart();

        Promise.resolve(mutation)
          .catch(error => {
            console.error('Error updating cart upsell:', error);
            const checkbox = document.querySelector('#cart-upsell-checkbox');
            if (checkbox) checkbox.checked = !isChecked;
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            if (errors) {
              errors.textContent = error?.status === 429
                ? 'To protect your cart from repeated automated requests, please refresh the page to verify your request, then try again.'
                : error?.message || 'Unable to update the cart.';
            }
          })
          .finally(() => {
            this.isMutating = false;
            const checkbox = document.querySelector('#cart-upsell-checkbox');
            if (checkbox) checkbox.disabled = false;
          });
      }
    });
  }

  async runCartMutation(fetcher) {
    if (window.MRCartMutationCoordinator) {
      return window.MRCartMutationCoordinator.mutate(fetcher, {
        maxRetries: 1,
        retryStatuses: [409],
        cooldownMs: 1200,
      });
    }

    const response = await fetcher({ attempt: 0 });
    const payload = await response.json().catch(() => null);
    if (!response.ok) {
      const error = new Error(payload?.description || payload?.message || 'Unable to update the cart.');
      error.status = response.status;
      error.payload = payload;
      throw error;
    }
    return { ok: true, status: response.status, payload, response };
  }

  getUpsellCheckboxVariantId() {
    return document.querySelector('#cart-upsell-checkbox')?.getAttribute('data-variant-id');
  }

  updateCheckboxState() {
    fetch(`${this.baseUrl}.js`)
      .then(response => response.json())
      .then(cart => {
        const hasUpsellCheckbox = cart.items.some(item => item.variant_id.toString() === this.checkboxUpsellVariantId);
        const checkboxUpsellCheckbox = document.querySelector('#cart-upsell-checkbox');
        if (checkboxUpsellCheckbox) {
          checkboxUpsellCheckbox.checked = hasUpsellCheckbox;
        }
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  handleCartUpdate() {
    setTimeout(() => this.updateCheckboxState(), 500); 
  }

  async addUpsellCheckboxToCart() {
    const formData = new FormData();
    formData.append('id', this.checkboxUpsellVariantId);
    formData.append('quantity', 1);

    await this.runCartMutation(() => fetch(`${this.baseUrl}/add.js`, {
      method: 'POST',
      body: formData
    }));

    if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === 'function') {
      await this.cartItemsInstance.onCartUpdate();
      this.onCartUpdateCheckboxUpsell();
    }
  }

  async removeUpsellCheckboxFromCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh the cart.');
    const cart = await response.json();
    const lineItemIndex = cart.items.findIndex(item => item.variant_id.toString() === this.checkboxUpsellVariantId);
    if (lineItemIndex === -1) return;

    const item = cart.items[lineItemIndex];
    const identity = {
      key: item.key || '',
      bundleId: String(item.properties?._mamaraya_bundle_id || ''),
      configId: String(item.properties?.['_Configuration ID'] || ''),
      variantId: String(item.variant_id || item.id || ''),
      line: lineItemIndex + 1,
      forceLine: false,
    };
    await this.cartItemsInstance.updateQuantity(identity.line, 0, null, identity.variantId, identity);
  }

getSectionsToRenderCheckboxUpsell() {
  const mainCartFooter = document.getElementById('main-cart-footer');
  const sections = [
    ...(mainCartFooter ? [{
      id: 'main-cart-footer',
      section: mainCartFooter.dataset.id,
      selector: '#main-cart-footer .js-contents',
    }] : []),
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '#cart-icon-bubble',
    },
  ];
  return sections;
}

  
  onCartUpdateCheckboxUpsell() {
    this.getSectionsToRenderCheckboxUpsell().forEach(section => {
      fetch(`${routes.cart_url}?section_id=${section.section}`)
        .then(response => response.text())
        .then(html => {
          const container = document.querySelector(section.selector);
          if (!container) {
            console.error(`Container not found for selector: ${section.selector}`);
            return;
          }
          if (section.id === 'main-cart-footer') {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const jsContents = doc.querySelector('.js-contents');
  
            if (jsContents) {
              container.innerHTML = jsContents.innerHTML;
            } else {
              console.error(`.js-contents not found in fetched HTML for section: ${section.id}`);
            }
          } 
          else if (section.id === 'cart-icon-bubble') {
            container.innerHTML = html;
          }
        })
        .catch(error => console.error(`Error updating section ${section.id}:`, error));
    });
  }
  
}

document.addEventListener('DOMContentLoaded', function() {
    const cartItemsInstance = document.querySelector('cart-items');
    const cartDrawerItemsInstance = document.querySelector('cart-drawer-items');
    let activeCartInstance = cartDrawerItemsInstance || cartItemsInstance; 
    if (activeCartInstance) {
        new CartCheckboxUpsell(activeCartInstance);
    } else {
        console.log("Neither cart-items nor cart-drawer-items found in the DOM.");
    }
});
